import { Link } from "react-router-dom";
import { TbBuildingStore } from "react-icons/tb";
import { formatCurrency } from "../../../../Utils/formatters";
import { highlightSearchText } from "../highlightSearchText";

interface OrganizerCardProps {
  name: string;
  idCustomer?: string;
  totalValue?: number;
  isActive?: boolean;
  subAccountId?: string;
  highlight?: string;
  canNavigate?: boolean;
}

export function OrganizerCard({
  name,
  idCustomer,
  totalValue = 0,
  isActive = true,
  subAccountId,
  highlight,
  canNavigate = false,
}: OrganizerCardProps) {
  const content = (
    <>
      <div className="mb-3 flex items-start justify-between gap-2">
        <div className="flex min-w-0 items-start gap-2.5">
          <div className="summary-card-icon mt-0.5">
            <TbBuildingStore className="h-4 w-4 text-[#e7a73f]" />
          </div>
          <div className="min-w-0">
            <p className="truncate text-sm font-bold text-brand-dark dark:text-gray-100">
              {highlightSearchText(name, highlight)}
            </p>
            {idCustomer ? (
              <p className="truncate text-xs text-gray-500 dark:text-gray-400">
                {highlightSearchText(idCustomer, highlight)}
              </p>
            ) : null}
          </div>
        </div>
        <span
          className={`mt-1 h-2.5 w-2.5 shrink-0 rounded-full ${
            isActive ? "bg-emerald-500" : "bg-red-500"
          }`}
          aria-label={isActive ? "Ativo" : "Inativo"}
        />
      </div>
      <p className="text-lg font-bold text-brand-dark dark:text-gray-100">
        {formatCurrency(totalValue)}
      </p>
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">Saldo disponível</p>
    </>
  );

  if (canNavigate && subAccountId) {
    return (
      <Link
        to={`/pontos-de-venda/${subAccountId}`}
        className="summary-card block no-underline transition hover:border-[#e7a73f]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#e7a73f]/40"
      >
        {content}
      </Link>
    );
  }

  return <div className="summary-card">{content}</div>;
}
